import type { ComponentProps } from "react"

/* Access-guard glyph set (`access-*`): the premium/upsell iconography from
 * the design bundle — badge, pill, chip and CTA glyphs. Kept as custom
 * icons (not fi-rr-*) so the shapes stay identical to the mocks. All draw
 * with currentColor so they recolor via the parent's `color`. */

type AccessSvgProps = ComponentProps<"svg">

function baseProps(props: AccessSvgProps): AccessSvgProps {
  const { viewBox = "0 0 24 24", ...rest } = props
  return { viewBox, xmlns: "http://www.w3.org/2000/svg", ...rest }
}

export function IconCustomAccessLock(props: AccessSvgProps) {
  return (
    <svg {...baseProps(props)} fill="currentColor">
      <rect x="5" y="11" width="14" height="9" rx="1.5" />
      <path
        d="M8 11V7a4 4 0 0 1 8 0v4"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function IconCustomAccessCrown(props: AccessSvgProps) {
  return (
    <svg {...baseProps(props)} fill="currentColor">
      <path d="M3 7l4 4 5-7 5 7 4-4-2 11H5z" />
    </svg>
  )
}

export function IconCustomAccessCode(props: AccessSvgProps) {
  return (
    <svg
      {...baseProps(props)}
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m16 18 6-6-6-6" />
      <path d="m8 6-6 6 6 6" />
    </svg>
  )
}

export function IconCustomAccessFlag(props: AccessSvgProps) {
  return (
    <svg
      {...baseProps(props)}
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 21V4" fill="none" />
      <path d="M5 4c4-2.5 8 2.5 14 0v9c-6 2.5-10-2.5-14 0Z" />
    </svg>
  )
}

export function IconCustomAccessUsers(props: AccessSvgProps) {
  return (
    <svg {...baseProps(props)} fill="currentColor">
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6Z" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M17.5 14.5c2.4.4 4 2.3 4 5h-3.6a8 8 0 0 0-1.6-4.6Z" />
    </svg>
  )
}
